define('home/views/ProfileCommentsModulePostView',[
    'backbone-marionette',
    'core/utils/html',

    'home/templates/profileCommentsModulePost',
    'home/mixins/withTruncate',
], function (
    Marionette,
    html,

    profileCommentsModulePostTemplate,
    withTruncate
) {
    'use strict';

    var ProfileCommentsModulePostView = Marionette.ItemView.extend({
        template: profileCommentsModulePostTemplate,
        className: 'post-comments__wrapper',

        templateHelpers: function () {
            var postActivity = this.getPostActivity();

            return {
                discussionRoute: this.model.thread.getDiscussionRoute(),
                postActivity: postActivity.toJSON(),
                relativeTime: postActivity.getRelativeCreatedAt(),
                message: html.stripTags(postActivity.object.get('message')),
            };
        },

        // The backend does not group activities for this feed,
        // so there should only be 1 activity to display
        getPostActivity: function () {
            return this.model.activities[0];
        },
    });

    withTruncate.call(ProfileCommentsModulePostView.prototype);

    return ProfileCommentsModulePostView;
});

